<template>
  <widget
    :color="color"
    icon="fa fa-phone-alt"
    title="Outbound calls today"
    :value="value"
  />
</template>

<script>
import apiRealtime from '@/apis/realtime'

import Widget from '@/components/widget/widget8'

export default {
  props: {
    refresh: Boolean
  },
  components: {
    Widget
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      value: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        this.getVoiceCall()
      }
    }
  },
  methods: {
    async getVoiceCall() {
      try {
        const getVoiceCall = await apiRealtime.getVoiceCall()
        this.value = getVoiceCall.total

        this.$emit('reset', 'voiceCall')
      } catch (error) {}
    }
  }
}
</script>
